import React from 'react';
import './Header.css';
import PropTypes from 'prop-types';
import { meteocat } from '../../img/';
import { headerColors } from '../../utils/utils';
import { links } from '../../utils/urls';

const Header = props => {
    const styles = headerColors(props.color);

    return (
        <div
            className="mc-widget-header"
            style={{
                backgroundColor: props.color,
            }}
        >
            <a href={links.baseMeteo}>
                <svg width="60" height="20" viewBox="0 0 60 17" fill="none">
                    <rect
                        x="0"
                        y="0"
                        width="60"
                        height="21"
                        fill="#fff"
                        fillOpacity="1"
                        transform="translate(0 -2)"
                    />
                    <rect
                        x="40"
                        y="0"
                        width="20"
                        height="21"
                        fill={styles.colors.color2}
                        fillOpacity={styles.alphas.alpha1}
                        transform="translate(0 -2)"
                    />
                    <rect
                        x="20"
                        y="0"
                        width="20"
                        height="21"
                        fill={styles.colors.color3}
                        fillOpacity={styles.alphas.alpha2}
                        transform="translate(0 -2)"
                    />
                    <rect
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                        fill={styles.colors.color1}
                        fillOpacity={styles.alphas.alpha3}
                        transform="translate(0 -2)"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.9518 13.8312L12.4837 11.3818L11.4712 12.3875L13.9387 14.8362L14.9518 13.8312ZM1.97192 2.96179L4.44067 5.41116L5.45317 4.40616L2.98442 1.95679L1.97192 2.96179ZM13.9387 1.95679L11.4712 4.40616L12.4837 5.41116L14.9518 2.96179L13.9387 1.95679ZM2.98442 14.8362L5.45317 12.3875L4.44067 11.3818L1.97192 13.8312L2.98442 14.8362ZM13.4331 9.10742H16.9237V7.68555H13.4331V9.10742ZM0 9.10742H3.49062V7.68555H0V9.10742ZM7.74634 16.7931H9.17821V13.3293H7.74634V16.7931ZM7.74634 3.46375H9.17821V0H7.74634V3.46375ZM3.90991 8.39627C3.90991 5.90189 5.94804 3.87939 8.46179 3.87939C10.9762 3.87939 13.0143 5.90189 13.0143 8.39627C13.0143 10.8913 10.9762 12.9138 8.46179 12.9138C5.94804 12.9138 3.90991 10.8913 3.90991 8.39627ZM5.39697 8.39623C5.39697 6.71686 6.76885 5.35498 8.46197 5.35498C10.1551 5.35498 11.527 6.71686 11.527 8.39623C11.527 10.0762 10.1551 11.4381 8.46197 11.4381C6.76885 11.4381 5.39697 10.0762 5.39697 8.39623V8.39623Z"
                        transform="translate(22)"
                        fill="#fff"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.0107422 1.6525H9.43574V0H0.0107422V1.6525ZM9.43566 6.68009H0.00878906L0.00941406 5.02759H9.43566V6.68009ZM9.43563 11.7074H0L0.005 10.0549H9.43563V11.7074V11.7074Z"
                        transform="translate(0 2)"
                        fill="#fff"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.59 11.715C12.995 12.24 13.3694 12.675 13.7981 12.9981L13.8006 14.3594C13.39 14.1719 13.0169 13.9306 12.6931 13.6444C11.8644 14.5394 10.5869 15.0894 9.1875 15.0894C7.7475 15.0894 6.43875 14.5075 5.6125 13.5681C5.2025 13.6756 4.76625 13.7331 4.31625 13.7331C2.05062 13.7331 0 12.225 0 10.1287C0 8.36937 1.455 7.01938 3.25062 6.63625C2.69375 4.2375 5.33375 3.15937 7.29688 3.05687C7.71187 1.25063 9.585 0 11.6756 0C12.4275 0 13.1525 0.1625 13.7925 0.455625V1.7825C13.2337 1.40188 12.5056 1.16375 11.6756 1.16375C9.71375 1.16375 8.4775 2.27875 8.355 4.2175C7.23 4.20375 4.74562 4.30875 4.39062 5.78C4.235 6.42688 4.7175 7.1025 5.01125 7.64375C3.58687 7.72313 1.17313 8.09125 1.17313 10.1287C1.17313 11.3731 2.46562 12.5694 4.31625 12.5694C4.97187 12.5694 5.4475 12.41 6.05188 12.1931C6.84313 13.3337 7.75875 13.9263 9.1875 13.9263C10.9388 13.9263 11.745 13.0963 12.59 11.715"
                        transform="translate(46 1)"
                        fill="#fff"
                    />
                </svg>
            </a>
            <a href={links.baseMeteo}>
                <img src={meteocat} alt="meteocat" />
            </a>
        </div>
    );
};

Header.propTypes = {
    color: PropTypes.string,
    logo: PropTypes.string,
};

export default Header;



// WEBPACK FOOTER //
// ./src/partials/Header/Header.js